import { generateRandomInteger } from "../../utils/general.utils";
export var generateRef = function () { return generateRandomInteger(10000); };
